const localeConstants = {
    rtlLangs : ['ar']
}

export default localeConstants